import SearchService from "../api/search"
import ArtifactService from "../api/artifact"
import ArchiveService from "../api/archive"

export const state = () => ({
    list: [],
    selected: [],
    saved_ids: [],
    saved_items: [],
    list_loaded: false,
    list_loading: false,
    current_page: 1,
    view: 'list',
    sort_by: 'title,asc',
    saved_count: 0,
    show_modal: false,
    modal_msg: '',
    shared_list: [],
    all_saved_items: [],
    all_shared_items: [],
})

export const actions = {
    async saved_ids  ({commit, state, rootState}) {
        if (state.list_loaded) return
        let savedIds = JSON.parse(localStorage.getItem(`${rootState.search.site}-saved-list`)) || [];

        commit('setListLoaded', true)
        commit('setIdList', savedIds);
        commit('setCount', savedIds.length);
    },
    async addItem({commit,state}, id) {
        let saved = state.saved_ids.concat([id]);
        commit('setIdList', saved);
        commit('setCount', saved.length);
    },
    async removeItem({commit,state}, id) {
        let saved = state.saved_ids.filter(savedId => {
            return id != savedId;
        });
        commit('setIdList', saved);
        commit('setCount', saved.length);
    },
    async saveSelected({state, dispatch}) {
        state.selected.forEach(id => {
            dispatch('addItem', id)
        });
        dispatch('clearSelected')
    },
    async removeSelected({state, dispatch}) {
        state.selected.forEach(id => {
            dispatch('removeItem', id)
        });
        dispatch('clearSelected')
    },
    async clearSelected({commit}) {
        commit('setSelected', []);
    },
    async stageItem({commit,state}, id) {
        let selected = state.selected.concat([id]);
        commit('setSelected', selected);
    },
    async unstageItem({commit,state}, id) {
        let selected = state.selected.filter(savedId => {
            return id != savedId;
        });
        commit('setSelected', selected);
    },
    async fetchAll({commit, state}, params) {
        let parts = state.sort_by.split(",");
        let savedIds = state.saved_ids;

        await SearchService.get_ids(params.locale, savedIds, parts[0], parts[1], params.page, params.size, params.type, 'medium')
        .then((response) => {
            commit('setCompleteList', response.data.results)
        })
        .catch((error) => {
            console.log(`Collections API Error => ${error}`)
        })
    },
    async fetchAllShared({commit, state}, params) {
        let parts = state.sort_by.split(",");

        await SearchService.get_ids(params.locale, params.ids, parts[0], parts[1], params.page, params.size, params.type, 'medium')
        .then((response) => {
            commit('setCompleteShareList', response.data.results)
        })
        .catch((error) => {
            console.log(`Collections API Error => ${error}`)
        })
    },
    async fetch({commit, state}, params) {
        commit('setListLoading', true)
        let savedIds = JSON.parse(localStorage.getItem(`${params.site}-saved-list`)) || [];
        commit('setIdList', savedIds);
        commit('setCount', savedIds.length);
        commit('setPage', params.page)
        let parts = state.sort_by.split(",");
        params.size = params.size || 100;
        params.type = "all";
        
        if (savedIds.length == 0) return;

        await SearchService.get_ids(params.locale, savedIds, parts[0], parts[1], params.page, params.size, params.type, 'medium')
        .then((response) => {
            commit('setList', response.data.results)
            commit('setListLoading', false)
        })
        .catch((error) => {
            console.log(`Collections API Error => ${error}`)
        })
    },
    async fetchShared({commit, state}, params) {
        commit('setListLoading', true)
        let parts = state.sort_by.split(",");
        params.size = 100;
        params.type = "all";
        commit('setPage', params.page)

        await SearchService.get_ids(params.locale, params.ids, parts[0], parts[1], params.page, params.size, params.type, 'medium')
        .then((response) => {
            commit('setSharedList', response.data.results)
            commit('setListLoading', false)
        })
        .catch((error) => {
            console.log(`Collections API Error getting Shared List => ${error}`)
        })
    },
    async selectAllSaved({commit, state}) {
        commit('setSelected', state.saved_ids);
    },
    async selectAllResults({commit, state, rootState}) {
        let type =  rootState.search.type;
        let locale =  rootState.search.locale;
        let sort =  rootState.search.sort;
        let order =  rootState.search.order;
        let page =  1;
        let size =  2000;
        let output = 'min';
        let q = rootState.search.query;

        if (rootState.search.facets_query) {
            q = q.concat(rootState.search.facets_query)
        }

        if (type == 'artifact') {
            await ArtifactService.search(locale, q, sort, order, page, size, output)
            .then((response) => {
                let ids = response.data.results.map(r => r.id).filter(id => !state.saved_ids.includes(id))
                commit('setSelected', ids)
            })
            .catch((error) => {
                console.log(`Collections API Error => ${error}`)
            })
        } else if (type == 'archive') {
            await ArchiveService.search(locale, q, sort, order, page, size, output)
            .then((response) => {
                let ids = response.data.results.map(r => r.id).filter(id => !state.saved_ids.includes(id))
                commit('setSelected', ids)
            })
            .catch((error) => {
                console.log(`Collections API Error => ${error}`)
            })
        } else {
            await SearchService.search(locale, q, sort, order, page, size, type, output)
            .then((response) => {
                let ids = response.data.results.map(r => r.id).filter(id => !state.saved_ids.includes(id))
                commit('setSelected', ids)
            })
            .catch((error) => {
                console.log(`Collections API Error => ${error}`)
            })
        }
    },
    async view({commit}, params) {
        commit('setView', params)
    },
    async sort_by ({commit}, params) {
        commit('setSortBy', params);
    },
    async clear ({commit}) {
        commit('setList', [])
    },
    async showModal ({commit}, params) {
        commit('setModal', params.display)
        commit('setModalMsg', params.msg)
    }
}

export const mutations = {
    setCount(state, data) {
        state.saved_count = data
    },
    setView(state, data) {
        state.view = data
    },
    setIdList(state, data) {
        localStorage.setItem(`${this.state.search.site}-saved-list`, JSON.stringify(data))
        state.saved_ids = data
    },
    setSelected(state, data) {
        state.selected = data;
    },
    setList(state, data) {
        state.list = data
        state.saved_items = data
        state.list_loaded = true
        state.list_loading = false
    },
    setListLoading(state, loading) {
        state.list_loading = loading
    },
    setListLoaded(state, loaded) {
        state.list_loaded = loaded
    },
    setSortBy(state, params) {
        state.sort_by = params
    },
    setPage(state, data) {
        state.current_page = parseInt(data);
    },
    setModal(state, data) {
        state.show_modal = data;
    },
    setModalMsg(state, data) {
        state.modal_msg = data;
    },
    setSharedList(state, data) {
        state.shared_list = data;
    },
    setCompleteList(state, data) {
        state.all_saved_items = data;
    },
    setCompleteShareList(state, data) {
        state.all_shared_items = data;
    },
}

export const getters = {
    json_ld() {
        return {
            "@context": "http://schema.org",
            "@type": "WebSite",
            name: "",
            description: "",
            url: ""
        }
    },
    saved_count(state) {
        return state.saved_count
    },
    view(state) {
        return state.view
    },
    saved_items(state) {
        return state.saved_items
    },
    saved_ids(state) {
        return state.saved_ids
    },
    list_loading(state) {
        return state.list_loading
    },
    sort_by(state) {
        return state.sort_by
    },
    selected(state) {
        return state.selected
    },
    selected_count(state) {
        return state.selected.length
    },
    current_page(state) {
        return state.current_page;
    },
    show_modal(state) {
        return state.show_modal;
    },
    modal_msg(state) {
        return state.modal_msg;
    },
    shared_list(state) {
        return state.shared_list;
    },
    all_saved_items(state) {
        return state.all_saved_items;
    },
    all_shared_items(state) {
        return state.all_shared_items;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
